import {showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {useAutocarisAuthenticateMutation, useGetAutocarisPlatformQuery} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationForm,
  PlatformAuthenticationFormProps,
} from './PlatformAuthenticationForm';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';
import {PlatformSettingsPromptBridge} from './PlatformSettingsPromptBridge';

export function PlatformSettingsAutocaris() {
  return (
    <>
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_AUTOCARIS_PROMPT_BRIDGE}>
        <PlatformSettingsPromptBridge code={AdvertisingPlatformCodeEnum.AUTOCARIS} />
      </Show>
      <Show whenFeatureDisabled={featureFlags.ADVERTISEMENT_AUTOCARIS_PROMPT_BRIDGE}>
        <PlatformCredentialsAutocarisLegacy />
      </Show>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.AUTOCARIS} />
    </>
  );
}

function PlatformCredentialsAutocarisLegacy() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetAutocarisPlatformQuery({params});
  const [saveAuthentication] = useAutocarisAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <PlatformAuthenticationForm
      values={data?.credentials}
      isFetching={isFetching}
      isError={isError}
      onSubmit={onSubmitCredentials}
    />
  );
}
